export const productOfferingQueryKey = {
  // TODO clean up the query key
  _productOffering: ['offering'],
  _productOfferingWritingCompany: (offeringId?: string) => [
    ...productOfferingQueryKey._productOffering,
    offeringId,
    'writing-company',
  ],
  getWritingCompany: (offeringId?: string) => [...productOfferingQueryKey._productOfferingWritingCompany(offeringId)],
  writingCompanies: ['writing-companies'],
};
